import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';
import { Typography } from '@material-ui/core';

const ClickableGoalsProgressChart = ({ combinedData, classes }) => {
  const handleBarClick = (data, category) => {
    let filterParam = '';
    
    switch(data.name) {
        case 'Profile Completion':
            if (category === 'complete') {
              filterParam = 'user_profile_completed=true';
            } else if (category === 'partial') {
              filterParam = 'user_profile_partially_completed=true';
            } else {
              filterParam = 'user_profile_partially_completed=false';
            }
            break;
      case 'Valuation Tool Usage':
        filterParam = category === 'complete' ? 'user_used_valuation=true' : 'user_used_valuation=false';
        break;
      case 'Search Usage':
        filterParam = category === 'complete' ? 'user_used_search=true' : 'user_used_search=false';
        break;
      case 'Personal Message Usage':
        filterParam = category === 'complete' ? 'personal_messages_sent=true' : 'personal_messages_sent=false';
        break;
      case 'Deal Room Usage':
        filterParam = category === 'complete' ? 'user_used_deal_room=true' : 'user_used_deal_room=false';
        break;
      case 'Business Continuity Usage':
        filterParam = category === 'complete' ? 'user_completed_continuity_builder=true' : 'user_completed_continuity_builder=false';
        break;
      default:
        break;
    }
    
    if (filterParam) {
      window.location.href = `/admin/user_admin?open_nav=true&${filterParam}`;
    }
  };

  const renderClickableBar = ({ category, fill }) => {
    return (
      <Bar 
        dataKey={category}
        stackId="a"
        fill={fill}
        onClick={(data) => handleBarClick(data, category)}
        cursor="pointer"
        isAnimationActive={false}
      >
        {category === 'complete' && <LabelList dataKey="complete_count" content={renderCustomLabel} />}
        {category === 'partial' && <LabelList dataKey="partial_count" content={renderCustomLabel} />}
        {category === 'incomplete' && <LabelList dataKey="incomplete_count" content={renderCustomLabel} />}
      </Bar>
    );
  };

  const renderCustomLabel = ({ value, x, y, width }) => {
    if (!value) return null;
    
    return (
      <text 
        fill="white" 
        fontSize={14} 
        textAnchor="middle" 
        x={x + width / 2}
        y={y + 15}
      >
        {value}
      </text>
    );
  };

  return (
    <>
      <Typography variant="h5" className={classes.subtitle}>
        Goals Progress
      </Typography>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={combinedData}
          layout="horizontal"
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip 
            formatter={(value, name) => {
              if (name === 'complete') return [`${value}% Complete`, 'Complete'];
              if (name === 'partial') return [`${value}% Partial`, 'Partial'];
              if (name === 'incomplete') return [`${value}% Incomplete`, 'Incomplete'];
              return [value, name];
            }}
          />
          <Legend />
          {renderClickableBar({ category: 'complete', fill: '#639754' })}
          {renderClickableBar({ category: 'partial', fill: '#FFD301' })}
          {renderClickableBar({ category: 'incomplete', fill: '#E03C32' })}
        </BarChart>
      </ResponsiveContainer>
      <div style={{ textAlign: 'center', marginTop: '10px', fontSize: '0.9rem', color: '#666' }}>
        Click on any bar segment to view filtered user list
      </div>
    </>
  );
};

export default ClickableGoalsProgressChart;
